"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarToggleButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useHovered = require("../../../util/useHovered");
var _useFocusElement = require("../hooks/useFocusElement");
var _ToolbarButtonBase = require("./ToolbarButtonBase");
const ToolbarToggleButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    isChecked,
    children,
    width,
    maxWidth,
    textAlign,
    isTooltipVisualOnly,
    ...rest
  } = _ref;
  const {
    isHovered,
    onMouseEnter,
    onMouseLeave
  } = (0, _useHovered.useHovered)({
    onMouseEnter: rest.onMouseEnter,
    onMouseLeave: rest.onMouseLeave
  });
  const focusProps = (0, _useFocusElement.useFocusElement)({
    targetRef: ref,
    onFocus: rest.onFocus,
    onKeyDown: rest.onKeyDown,
    onBlur: rest.onBlur
  });
  const switchProps = {
    role: "switch",
    "aria-checked": Boolean(isChecked)
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ToolbarButtonBase.ToolbarButtonBase, (0, _extends2.default)({}, switchProps, {
    ref: focusProps.ref
  }, rest, {
    isChecked: isChecked,
    isHovered: isHovered,
    text: children,
    onFocus: focusProps.onFocus,
    onBlur: focusProps.onBlur,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onKeyDown: focusProps.onKeyDown,
    tabIndex: rest.tabIndex === 0 ? rest.tabIndex : focusProps.tabIndex,
    tooltipVisualOnly: isTooltipVisualOnly,
    width: width,
    maxWidth: maxWidth,
    textAlign: textAlign,
    onClick: e => {
      rest.onClick(e);

      // if a click away listener is present. If this line isn't here, the click fires
      // multiple times an results in an immediate open/close of the overflow toolbar.
      e.nativeEvent.stopImmediatePropagation();
    }
  })));
});
exports.ToolbarToggleButton = ToolbarToggleButton;
ToolbarToggleButton.displayName = "ToolbarToggleButton";
//# sourceMappingURL=ToolbarToggleButton.js.map